import EmploymentAllowanceText from '@/components/requests/EmploymentAllowanceText'

export default class EmploymentAllowanceUnlimitedText extends EmploymentAllowanceText {
  getText() {
    return `Allowance is not affected, because ${this._getOwnerText()} allowance is set up as unlimited`
  }
}
